import { ProductSlug } from "@/api/product-api";
import { getProductDetailHref } from "@/libs/product/detail-href";

/**
 * 홈 팝업의 EXOSHOCK 슬라이드 — 문구 · 링크 스위치.
 *
 * 디자인 정본: Figma `[디자인] Website` › EXOSHOCK — Pop-up (`31842:70015`). 문구는 기획(2026-10-30)이 정하고 디자이너가
 * 시안에 반영했다 — 7개 언어 키(`exoshockPopupBadge` · `Eyebrow` · `Title` · `Cta` · `Note`)는
 * `public/translations/{locale}/event.json`. 받은 문구가 영어뿐이라 7개 언어 모두 영어다(승인 안 된 번역을 내보내지 않는다).
 *
 * `false` 로 되돌리면 prod 에 띄우지 않고(빈 카드 금지) 비-prod 는 배경만 띄운다.
 */
export const EXOSHOCK_POPUP_COPY_READY = true;

/** 광고하는 번들 — 이 번들이 판매 목록(`useValidBundles`)에 있을 때만 슬라이드를 띄운다. */
export const EXOSHOCK_POPUP_BUNDLE_SLUG = ProductSlug.EXOSHOCK_BUNDLE;

/**
 * CTA 링크 — 그 번들 PDP. PDP 링크는 헬퍼가 만든다(리다이렉트 홉 방지 · `__tests__/ci/redirect-hops.test.ts`).
 * `null` 이면 CTA 를 그리지 않는다.
 */
export const EXOSHOCK_POPUP_CTA_HREF: string | null = getProductDetailHref(
  EXOSHOCK_POPUP_BUNDLE_SLUG,
);
